module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [(_vm.state == 'reset' || _vm.state == 'resent') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text({
    email: _vm.email
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.state != 'reset' && _vm.state != 'resent') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e(), _vm._v(" "), (_vm.error == 'wrongPassword') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v(_vm._s(_vm.i18n().resetButton))]) : _vm._e(), _vm._v(" "), (_vm.error == 'registrationNotConfirmed') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v(_vm._s(_vm.i18n().resendButton))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.login
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.i18n().email))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.i18n().password))])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().registerText) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n().registerLink))])], 1), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f57ee6a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/LoginForm.vue
// module id = 472
// module chunks = 0